import apiClient from "./apiClient";
import {KindergartenSpecialStandard} from "@/types/kindergarten";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function findAllKindergartenSpecialStandard(): Promise<KindergartenSpecialStandard[]> {
    try {
        const response = await apiClient.get<KindergartenSpecialStandard[]>(
            `${BASE_URL}/api/v1/kindergarten/special/standard/list`,
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching kindergarten special standard list:", error);
        throw error;
    }
}

export async function uploadKindergartenSpecialStandardXlsx(formData: FormData) {
    try {
        const response = await apiClient.post(
            `${BASE_URL}/api/v1/kindergarten/special/standard/upload/using/xlsx`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
            return response;
        }).catch((error) => {
            return Promise.reject(error);
        });
        return response.data;
    } catch (error) {
        console.log("error on uploading file: ", error);
        throw error;
    }
}

